/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsDiscountTypesCtrl
 * @description
 */
angular.module('mercury.modules.reports.discounts')
.controller('ReportsDiscountTypesCtrl', ["PosDiscounts", "ReportPosStaff", "reporttime", "$scope", "$stateParams", "title", function(PosDiscounts, ReportPosStaff, reporttime, $scope, $stateParams, title) {
  if ($stateParams.staffId && $stateParams.staffName) {
    title.set('Discount Types Report For ' + $stateParams.staffName);
    $scope.loading = ReportPosStaff.getDiscountsForStaff(reporttime.start(), reporttime.end(), $stateParams.staffId);
  } else {
    title.set('Discount Types Report');
    $scope.loading = PosDiscounts.get(reporttime.start(), reporttime.end());
  }

  $scope.loading.then(function(results) {
    $scope.discountTypes = results;
  });

  $scope.discountTypesColumns = [
    {label: 'Discount Types', type: 'string', key: 'discountType'},
    {label: 'Amount', type: 'number', key: 'discountsAmount', filter: 'currency'}
  ];
}]);
